import React from 'react'
import { Select, Input } from '@peracto/peracto-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/pro-regular-svg-icons/faTimesCircle'

import { operatorValues } from './ConditionsListForm'

const stringOperatorValues = [{ label: 'Equals', value: '=' }]
const STRING_OPERATOR_TYPES = ['text', 'string']

export const ConditionsListValue = props => {
    const { form, field, valIdx, index, remove, attributeValues } = props

    return (
        <div className="form-row">
            <div className="col-12 col-md-6">
                <div data-testid={`values-${index}-dropdown-${valIdx}`}>
                    <Select
                        name={`${field.name}.${valIdx}.operation`}
                        placeholder="Select..."
                        options={
                            STRING_OPERATOR_TYPES.includes(
                                form.values.options.attributes[index].attribute.dataType
                            )
                                ? stringOperatorValues
                                : operatorValues
                        }
                    />
                </div>
            </div>
            <div className="col-12 col-md-5">
                {attributeValues?.length > 0 ? (
                    <Select
                        name={`${field.name}.${valIdx}.value`}
                        placeholder="Select..."
                        options={attributeValues.map(opt => ({
                            label: opt.label,
                            value: opt.value ? opt.value : opt.label,
                        }))}
                    />
                ) : (
                    <>
                        <div data-testid={`values-${index}-operator-${valIdx}`}>
                            <Input
                                name={`${field.name}.${valIdx}.value`}
                                type={
                                    form?.values?.options?.attributes[index]?.attribute?.dataType ||
                                    'text'
                                }
                            />
                        </div>
                    </>
                )}
            </div>

            <div className="col-12 col-md-1">
                {valIdx > 0 && (
                    <div className="d-flex justify-content-end">
                        <button
                            className="btn btn-link px-0"
                            onClick={e => {
                                e.preventDefault()
                                remove(valIdx)
                            }}
                            data-testid={`remove-rule-${index}-values-${valIdx}`}
                        >
                            <FontAwesomeIcon icon={faTimesCircle} />
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
